import { gql } from '@apollo/client';

export const GET_CONTACT_EVENT_LIST_INFO = gql`
  query MyQuery {
    getContactEventList {
      events {
        eventData {
          name
          id
        }
      }
    }
  }
`;
